import { render, staticRenderFns } from "./LegacyRoleForm.vue?vue&type=template&id=6abae93a&scoped=true&lang=html&"
import script from "./LegacyRoleForm.vue?vue&type=script&lang=js&"
export * from "./LegacyRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./LegacyRoleForm.vue?vue&type=style&index=0&id=6abae93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abae93a",
  null
  
)

export default component.exports